// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-indent[data-v-0ee987af]{padding-left:34px}.content-indent[data-v-0ee987af],.reply-indent[data-v-0ee987af]{border-left:1px solid var(--gray);margin-left:22px}.reply-indent[data-v-0ee987af]{padding-left:20px}.load-more-reply[data-v-0ee987af]{padding:1.25rem 3rem;color:#007bff}.load-more-reply>a[data-v-0ee987af]{color:#007bff;cursor:pointer}.load-more-reply>a[data-v-0ee987af]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
